/**
 * Completion timestamp for the current inspect activity.
 * Extended inspections keep write-once startTime but must record a new endTime.
 */
export function stampInspectionEndTime<T extends { endTime?: string }>(
  inspection: T,
  nowIso: string = new Date().toISOString()
): T {
  inspection.endTime = nowIso;
  return inspection;
}
